module.exports = __webpack_public_path__ + "img/20200507_134819.29865d33.jpg";